<template>
    <div>
        <nav ref="menu" class="relative inline-block" aria-label="Backstage">
            <button type="button"
                class="flex h-11 items-center gap-3 rounded-lg bg-nomad-900 px-4 text-sm font-semibold text-white hover:bg-nomad-800"
                :aria-expanded="open" aria-haspopup="true" @click="open = !open">
                {{ currentLabel }}
                <span class="icon-chevron-down text-nomad-accent transition-transform" :class="{ 'rotate-180': open }" aria-hidden="true"></span>
            </button>
            <div v-if="open"
                class="absolute left-0 top-full z-30 mt-2 max-h-[70vh] w-56 overflow-y-auto rounded-xl bg-nomad-800 p-2 shadow-xl">
                <Link v-for="item in menu" :key="item.href" :href="item.href"
                    class="block rounded-lg px-3 py-2 text-sm font-medium"
                    :class="isActive(item.href) ? 'bg-nomad-accent text-nomad-900' : 'text-nomad-50 hover:bg-nomad-700 hover:text-white'"
                    :aria-current="isActive(item.href) ? 'page' : null"
                    @click="open = false">
                    {{ item.label }}
                </Link>
            </div>
        </nav>
        <div class="w-full">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { Link } from "@inertiajs/vue3";
export default {
    components: {
        Link,
    },
    data() {
        return {
            open: false,
            menu: [
                { href: "/backstage", label: "Home" },
                { href: "/backstage/artists", label: "Artists" },
                { href: "/backstage/artist-battles", label: "Artist Battles" },
                { href: "/backstage/songs", label: "Songs" },
                { href: "/backstage/albums", label: "Albums" },
                { href: "/backstage/events", label: "Events" },
                { href: "/backstage/pages", label: "Pages" },
                { href: "/backstage/audiobooks", label: "Audio Books" },
                { href: "/backstage/playlist", label: "Playlist" },
                { href: "/backstage/story", label: "Stories" },
                { href: "/backstage/scholars", label: "Scholars" },
                { href: "/backstage/topics", label: "Topics" },
                { href: "/backstage/resources", label: "Resources" },
                { href: "/backstage/luuqa", label: "Luuqa" },
            ],
        };
    },
    computed: {
        currentLabel() {
            return this.menu.find((item) => this.isActive(item.href))?.label ?? "Menu";
        },
    },
    mounted() {
        document.addEventListener("click", this.closeOnOutsideClick);
        document.addEventListener("keydown", this.closeOnEscape);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.closeOnOutsideClick);
        document.removeEventListener("keydown", this.closeOnEscape);
    },
    methods: {
        closeOnOutsideClick(event) {
            if (!this.$refs.menu?.contains(event.target)) this.open = false;
        },
        closeOnEscape(event) {
            if (event.key === "Escape") this.open = false;
        },
        isActive(href) {
            const path = this.$page.url.split("?")[0];
            return href === "/backstage" ? path === href : path === href || path.startsWith(href + "/");
        },
    },
};
</script>
